(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ace-online-store-directory"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ace-category-directory'))customElements.define('ace-category-directory',class extends HTMLElement{
  connectedCallback(){
    if(this.dataset.ready)return;
    this.dataset.ready='true';
    const search=this.querySelector('[data-search]');
    if(!search)return;
    const cards=Array.from(this.querySelectorAll('[data-store]'));
    const count=this.querySelector('[data-count]');
    const normalize=value=>value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').replace(/[’']/g,'');
    const update=()=>{const terms=normalize(search.value.trim()).split(/\s+/).filter(Boolean);let total=0;cards.forEach(card=>{card.hidden=!terms.every(term=>normalize(card.dataset.name).includes(term));if(!card.hidden)total++;});count.textContent=`${total} ${total===1?count.dataset.one:count.dataset.many}`;this.querySelector('[data-empty]').hidden=total>0;};
    this.querySelector('[data-tools]').hidden=false;
    search.addEventListener('input',update);update();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ace-retail-project"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ace-project-form')) {
  customElements.define('ace-project-form', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const family = this.querySelector('[data-family]');
      const details = this.querySelector('[data-details]');
      if (!family || !details) return;
      const update = () => {
        const chosen = Boolean(family.value) || Boolean(this.querySelector('[role="alert"]'));
        details.hidden = !chosen;
        details.disabled = !chosen;
        family.setAttribute('aria-expanded', String(chosen));
      };
      family.addEventListener('change', update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ace-service-intake"]) return;
  try {
    
const acePackage=document.getElementById('AcePackage');if(acePackage){const q=new URLSearchParams(location.search);const value=(q.get('tier')||q.get('package')||'').replace(' — quote required','').replace(' — request required','');if([...acePackage.options].some(o=>o.value===value))acePackage.value=value;}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ace-service-product"]) return;
  try {
    
document.querySelectorAll('[data-ace-service-product]').forEach(root=>{const select=root.querySelector('[data-ace-tier]');if(!select)return;const show=()=>{root.querySelectorAll('[data-ace-variant]').forEach(p=>{p.hidden=p.dataset.aceVariant!==select.value});const sku=select.selectedOptions[0].dataset.sku;root.querySelectorAll('[data-tier-sku]').forEach(p=>{p.hidden=p.dataset.tierSku!==sku});const url=new URL(location.href);url.searchParams.set('variant',select.value);url.searchParams.delete('tier');history.replaceState(null,'',url)};const params=new URLSearchParams(location.search);const tiers={essentials:'ACE-EVENT-ESSENTIALS',collection:'ACE-EVENT-COLLECTION',registration:'ACE-EVENT-REGISTRATION',hub:'ACE-EVENT-HUB'};const option=[...select.options].find(o=>o.value===params.get('variant')||o.dataset.sku===tiers[params.get('tier')]);if(option)select.value=option.value;show();select.addEventListener('change',show)});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ace-store-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ace-store-directory')) {
  customElements.define('ace-store-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.cards = Array.from(this.querySelectorAll('[data-store]'));
      this.search = this.querySelector('[data-search]');
      this.filters = Array.from(this.querySelectorAll('[data-filter]'));
      this.empty = this.querySelector('[data-empty]');
      this.count = this.querySelector('[data-count]');
      this.group = 'all';
      this.querySelector('[data-tools]').hidden = false;
      this.search.addEventListener('input', () => this.update());
      this.filters.forEach(button => button.addEventListener('click', () => {
        this.group = button.dataset.filter;
        this.filters.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.update();
      }));
      this.update();
    }
    update() {
      const normal = value => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, '');
      const terms = normal(this.search.value.trim()).split(/\s+/).filter(Boolean);
      let visible = 0;
      this.cards.forEach(card => {
        const groupMatch = this.group === 'all' || card.dataset.group === this.group;
        const name = normal(card.dataset.name);
        const match = groupMatch && terms.every(term => name.includes(term));
        card.hidden = !match;
        if (match) visible += 1;
      });
      this.empty.hidden = visible > 0;
      this.count.textContent = `${visible} ${this.count.dataset.label}`;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
